import { render, staticRenderFns } from "./UndergroundToken.vue?vue&type=template&id=52b3bd8f"
import script from "./UndergroundToken.vue?vue&type=script&lang=ts"
export * from "./UndergroundToken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports